import BaseCtrl from 'edge/platform/base/BaseCtrl';
class PUWVinLookupCtrl {

    constructor($scope, VinLookupEnabled, VinLookupService, SearchService, $q, $filter, $stateParams) {
        const ctrl = Object.create(BaseCtrl);
        $scope.searchParam = null;
        $scope.country = null;
        $scope.vehiclesD = null;
        $scope.vehicleSelected = false;
        $scope.vehicleInfos = [];
        $scope.vehicleInfoByLicense = [];
        $scope.searchRequest = {
            licensePlate: null,
            country: null,
            licensePlateSearch: null,
            licensePlateSearchErrors: null
        };
        ctrl.init = function () {
            this.searchVehicleByVIN($stateParams.searchParam);
        }
        $scope.isNscProducerCode = window.isNscProducerCode;
        if ($scope.isNscProducerCode) {
            VinLookupService.nscVINValidated = false;
            VinLookupService.nscSellerSiteValidated = false;
        }
        const alfaRomeoModels = ["147", "159", "4CSpider", "4C", "Brera", "GiuliaQuadrifoglio", "Giulia", "Giulietta", "Mito", "StelvioQuadrifoglio", "Stelvio", "Tonale", "GT"];
        const lanciaModels = ["Ypsilon", "Voyager", "Thema", "Flavia", "Delta"];
        const dsModels = ["DS3", "DS4", "DS5", "DS7", "DS8", "DS9"];

        //UCWAR-2028 Vehicle data to be filled in by external system
        $scope.searchVehicleByVIN = () => {
            VinLookupService.vinSearchTempData.emptyVinSearchData = false;
            VinLookupService.vinSearchTempData.revalidateError = false;
            $scope.searchParam = $scope.vehicle.vin.value;
            if ($scope.searchParam == undefined || $scope.searchParam == "") {
                VinLookupService.vinSearchTempData.emptyVinSearchData = true;
                return;
            }
            const searchResults = SearchService.searchVehicleByVIN($scope.searchParam);
            $scope.searchResultsPromise = searchResults;

            $q.when(
                searchResults,
                (searchResult) => {
                    $scope.vehiclesD = searchResult;
                    VinLookupService.vinSearchTempData.multipleVinResults = false;
                    $scope.populateVehicleResults();
                    if ($scope.vehicleInfos.length == 0) {
                        VinLookupService.vinSearchResponseFieldsCount = 1;
                    } else if ($scope.vehicleInfos.length == 1) {
                        autoFillSingleVehicleData(0);
                    } else {
                        $scope.disableDefaults();
                    }
                    VinLookupService.vinSearchTempData.isVinSearchCompleted = true;
                },
                (error) => {
                    VinLookupService.vinSearchTempData.isVinSearchCompleted = true;
                    VinLookupService.vinSearchTempData.multipleVinResults = false;
                    VinLookupService.vinSearchResponseFieldsCount = 1;
                    while ($scope.vehicleInfos.length > 0) {
                        $scope.vehicleInfos.pop();
                    }
                }
            );
        };

        $scope.autoFillSelectedVinData = (index) => {
            console.log(" index log : " + index);
            autoFillSingleVehicleData(index);
            VinLookupService.vinSearchTempData.multipleVinResults = false;
            $scope.vehicleSelected = true;
        }

        const autoFillSingleVehicleData = (index) => {
            let vehicle = $scope.vehicleInfos[index];
            fillVehicleInfo(vehicle);
            $scope.disableDefaults();
            $scope.disableFields(vehicle);
        }

        const fillVehicleInfo = (vehicle) => {
            let producerCodeCountry = $scope.vehicle.producerCodeCountry.value;

            if (vehicle.make != undefined) {
                $scope.vehicle.make.value = vehicle.make;
            }
            if (vehicle.vin != undefined) {
                $scope.vehicle.vin.value = vehicle.vin;
            }
            if (vehicle.model != undefined) {
                if (vehicle.make == 'alfaromeo') {
                    $scope.vehicle.alpharomeoModel_PSA_Temp.value = vehicle.model;
                } else if (vehicle.make == 'lancia') {
                    $scope.vehicle.lanciaModel_PSA_Temp.value = vehicle.model;
                } else {
                    $scope.vehicle.model.value = vehicle.model;
                }
            }
            //INCI12362794 | ITBOT : PB VOLTS : GVO SPAIN - PORTAL - ENERGY TYPE EMPTY BLOCKS SUBSCRIPTION
            let isEnergyExists = _.filter($scope.vehicle.typeOfEnergy.aspects.availableValues, function(e){return e.code == vehicle.typeOfEnergy})[0];
            if(isEnergyExists){
                if (vehicle.typeOfEnergy != undefined) {
                    $scope.vehicle.typeOfEnergy.value = vehicle.typeOfEnergy;
                }
            }
            //if (vehicle.typeOfEnergy != undefined) {
              //  $scope.vehicle.typeOfEnergy.value = vehicle.typeOfEnergy;
            //}
            if (vehicle.carPower != undefined &&
                producerCodeCountry != 'IT' && producerCodeCountry != 'DE') {
                $scope.vehicle.carPower.value = vehicle.carPower;
            }
            if (vehicle.carPowerKW != undefined && producerCodeCountry == 'DE') {
                $scope.vehicle.carPowerKW.value = vehicle.carPowerKW;
            }
            if (vehicle.carPowerKWIT != undefined && producerCodeCountry == 'IT') {
                $scope.vehicle.carPowerKWIT.value = vehicle.carPowerKWIT;
            }
            if (vehicle.firstRegistrationDate != undefined) {
                $scope.vehicle.firstRegistrationDate.value = vehicle.firstRegistrationDate;
            }
            if (vehicle.vehicleSpecificities != undefined) {
                $scope.vehicle.vehicleSpecificities = vehicle.vehicleSpecificities;
            }
            if (vehicle.license != undefined) {
                $scope.vehicle.license = vehicle.license;
            }
            if (vehicle.currentMileage != undefined) {
                $scope.vehicle.currentMileage = vehicle.currentMileage;
            }
            if (vehicle.vehicleType != undefined) {
                $scope.vehicle.vehicleType = vehicle.vehicleType;
            }
            if (vehicle.sellerSite != undefined) {
                $scope.vehicle.sellerSite = vehicle.sellerSite;
            }
        }
        $scope.disableFields = (vehicle) => {
            if (vehicle.make != null && vehicle.make != undefined) {
                VinLookupService.disableData.make = true;
                VinLookupService.vinSearchResponseFieldsCount++;
            }
            if ((vehicle.model != null && vehicle.model != undefined) &&
                ((vehicle.make == 'ds' && dsModels.includes(vehicle.model)) ||
                    (vehicle.make == 'lancia' && lanciaModels.includes(vehicle.model)) ||
                    (vehicle.make == 'alfaromeo' && alfaRomeoModels.includes(vehicle.model)) ||
                    (vehicle.make != 'ds' && vehicle.make != 'lancia' && vehicle.make != 'alfaromeo'))) {
                VinLookupService.disableData.model = true;
            }
            if (vehicle.model != null && vehicle.model != undefined) {
                VinLookupService.vinSearchResponseFieldsCount++;
            }
            if (vehicle.carPower != null && vehicle.carPower != undefined) {
                VinLookupService.disableData.carPower = true;
                VinLookupService.vinSearchResponseFieldsCount++;
            }
             //INCI12362794 | ITBOT : PB VOLTS : GVO SPAIN - PORTAL - ENERGY TYPE EMPTY BLOCKS SUBSCRIPTION
                let isEnergyExists = _.filter($scope.vehicle.typeOfEnergy.aspects.availableValues, function(e){return e.code == vehicle.typeOfEnergy})[0];
                if(isEnergyExists){
                    if (vehicle.typeOfEnergy != null && vehicle.typeOfEnergy != undefined) {
                        VinLookupService.disableData.energy = true;
                        VinLookupService.vinSearchResponseFieldsCount++;
                    }
                }
            //if (vehicle.typeOfEnergy != null && vehicle.typeOfEnergy != undefined) {
              //  VinLookupService.disableData.energy = true;
                //VinLookupService.vinSearchResponseFieldsCount++;
            //}
            if (vehicle.vehicleSpecificities != null && vehicle.vehicleSpecificities != undefined) {
                VinLookupService.disableData.vehicleSpec = true;
                VinLookupService.vinSearchResponseFieldsCount++;
            }
        }

        $scope.disableMakeFun = () => {
            return VinLookupService.disableData.make;
        }
        $scope.disableModelFun = () => {
            return VinLookupService.disableData.model;
        }

        $scope.disableDefaults = () => {
            VinLookupService.disableData.make = false;
            VinLookupService.disableData.model = false;
            VinLookupService.disableData.energy = false;
            VinLookupService.disableData.carPower = false;
            VinLookupService.disableData.vehicleSpec = false;
            VinLookupService.vinSearchResponseFieldsCount = 0;
        }

        $scope.enableVinSearch = () => {
            return VinLookupService.nscVINValidated &&
                ($scope.vehicle.producerCodeCountry.value == 'DE' || VinLookupService.vinSearchTempData.noResultOnLicenseSearch);
        }

        $scope.enableNSCVINButton = () => {
            return (!VinLookupService.nscVINValidated || VinLookupService.nscVin == undefined ||
                VinLookupService.nscVin != $scope.vehicle.vin.value) && $scope.isNscProducerCode;
        }

        $scope.populateVehicleResults = () => {
            while ($scope.vehicleInfos.length > 0) {
                $scope.vehicleInfos.pop();
            }
            $scope.vehiclesD.forEach((vehicle) => {
                if (vehicle != null && ($scope.vehicle.producerCodeLabel.value != 'alfaRomeoCertified' &&
                    $scope.vehicle.producerCodeLabel.value != 'LanciaCertifed' &&
                    $scope.vehicle.producerCodeLabel.value != 'DSCertified') ||
                    (vehicle.make == 'alfaromeo' && $scope.vehicle.producerCodeLabel.value == 'alfaRomeoCertified') ||
                    (vehicle.make == 'lancia' && $scope.vehicle.producerCodeLabel.value == 'LanciaCertifed') ||
                    (vehicle.make == 'ds' && $scope.vehicle.producerCodeLabel.value == 'DSCertified')) {
                    const vehInfo = {
                        vin: '',
                        typeOfEnergy: '',
                        model: '',
                        carPower: '',
                        make: '',
                        vehicleSpecificities: ''
                    };
                    vehInfo.vin = vehicle.vin ? vehicle.vin : $scope.searchParam;
                    vehInfo.model = vehicle.model;
                    vehInfo.typeOfEnergy = vehicle.typeOfEnergy;
                    let producerCodeCountry = $scope.vehicle.producerCodeCountry.value;
                    if (producerCodeCountry != 'IT' && producerCodeCountry != 'DE') {
                        vehInfo.carPower = vehicle.carPower;
                    } else if (producerCodeCountry == 'DE') {
                        vehInfo.carPowerKW = vehicle.carPowerKW;
                    } else if (producerCodeCountry == 'IT') {
                        vehInfo.carPowerKWIT = vehicle.carPowerKWIT;
                    }
                    vehInfo.make = vehicle.make;
                    vehInfo.vehicleSpecificities = vehicle.vehicleSpecificities;
                    $scope.vehicleInfos.push(vehInfo);
                }
            });

            if ($scope.vehicleInfos.length > 1) {
                VinLookupService.vinSearchTempData.multipleVinResults = true;
                $scope.vehicleSelected = false;
            }
            return $scope.vehicleInfos;
        };

        $scope.validateNSCVIN = () => {
            VinLookupService.nscNoVehicleInfo = false;
            VinLookupService.nscMoreResultFound = false;
            VinLookupService.nscValuesUpdated = false;
            VinLookupService.nscVin = $scope.vehicle.vin.value;
            VinLookupService.vinSearchTempData.emptyVinSearchData = false;
            if (VinLookupService.nscVin == undefined || VinLookupService.nscVin == "") {
                VinLookupService.vinSearchTempData.emptyVinSearchData = true;
                return;
            }
            VinLookupService.nscVINValidated = false;
            VinLookupService.vinSearchTempData.isLicenseSearchComplete = false;
            VinLookupService.vinSearchTempData.isVinSearchCompleted = false;
            VinLookupService.vinSearchTempData.noResultOnLicenseSearch = false;
            const nscResults = SearchService.validateNSCVIN(VinLookupService.nscVin);
            $scope.nscResultsPromise = nscResults;
            $q.when(nscResults,
                (nscData) => {
                    $scope.nscDataResult = nscData;
                    if ($scope.nscDataResult.length == 0) {
                        VinLookupService.nscNoVehicleInfo = true;
                    }
                    if ($scope.nscDataResult.length == 1) {
                        VinLookupService.nscVINValidated = true;
                        let vehicle = $scope.nscDataResult[0];
                        fillVehicleInfo(vehicle);
                    }
                    if ($scope.nscDataResult.length > 1) {
                        VinLookupService.nscMoreResultFound = true;
                    }
                    console.log("NSC search completed");
                },
                (error) => {
                    console.log("Error occurred while validating NSC VIN");
                }
            );
        }

        $scope.errorMsg = '';
        $scope.invalidVIN = null;
        $scope.oldAlfaRomeoModels = ['147', '159', '8C', 'Brera', 'GT'];
        $scope.alfaRomeoList = $scope.vehicle.alpharomeoModel_PSA_Temp.aspects.availableValues;
        $scope.lanciaModelsList = $scope.vehicle.lanciaModel_PSA_Temp.aspects.availableValues;
        //UCWPOLICY-1173
        $scope.vehicleMake = $scope.vehicle.make.aspects.availableValues.filter(item => item.code != 'other');
        //UCWAR-2751
        if (window.producerCodeLabel == 'alfaRomeoCertified') {
            //If producer code label = Alfa Romeo Certified then the Make will have only "Alfa Romeo" option
            $scope.vehicleMake = $scope.vehicle.make.aspects.availableValues.filter(item => item.code == 'alfaromeo');
            $scope.alfaRomeoList = $scope.alfaRomeoList.filter(item => !$scope.oldAlfaRomeoModels.includes(item.code));
        } else if (window.producerCodeLabel == 'LanciaCertifed') {
            //If producer code label = Lancia Certified then the Make will have only "Lancia" option
            $scope.vehicleMake = $scope.vehicle.make.aspects.availableValues.filter(item => item.code == 'lancia');
            $scope.lanciaModelsList = $scope.lanciaModelsList.filter(item => item.code == 'Ypsilon');
        } else if (window.producerCodeLabel == 'DSCertified') {
            //If producer code label = DS Certified then the Make will have only "DS" option
            $scope.vehicleMake = $scope.vehicle.make.aspects.availableValues.filter(item => item.code == 'ds');
        }

        $scope.$watch('invalidVIN', (newValue) => {
            $scope.readonly = newValue === false;
            $scope.errorMsg = '';
        });
        $scope.$watch('vehicle.alpharomeoModel_PSA_Temp.value', (nv, ov) => {
            if ($scope.vehicle.alpharomeoModel_PSA_Temp.value != undefined
                && $scope.vehicle.make.value.code == 'alfaromeo') {
                $scope.vehicle.model.value = $scope.vehicle.alpharomeoModel_PSA_Temp.value.name;
                $scope.vehicle.lanciaModel_PSA_Temp = undefined;
            }
        })
        $scope.$watch('vehicle.lanciaModel_PSA_Temp.value', (nv, ov) => {
            if ($scope.vehicle.lanciaModel_PSA_Temp.value != undefined
                && $scope.vehicle.make.value.code == 'lancia') {
                $scope.vehicle.model.value = $scope.vehicle.lanciaModel_PSA_Temp.value.name;
                $scope.vehicle.alpharomeoModel_PSA_Temp = undefined;
            }
        })
        //UCWAR-650 - default to ypsilon when make is lancia
        $scope.$watch('vehicle.make.value', (nv, ov) => {
            if ($scope.vehicle.make.value != undefined) {
                if ($scope.vehicle.make.value.code != 'lancia' && $scope.vehicle.make.value.code != 'alfaromeo') {
                    $scope.vehicle.lanciaModel_PSA_Temp = undefined;
                    $scope.vehicle.alpharomeoModel_PSA_Temp = undefined;
                    // $scope.vehicle.model.value = undefined;  // UCWAR-1822 - Commented this line
                } else if ($scope.vehicle.make.value.code == 'lancia') {
                    $scope.vehicle.lanciaModel_PSA_Temp.value = 'Ypsilon';
                }
            }
        })

        $scope.lookupVIN = () => {
            //UCWPRODENG-757 PROD ==> Two policies are subscribed with the same VIN 
            $scope.vehicle.vin.value = (!angular.isUndefined($scope.vehicle.vin.value)) || $scope.vehicle.vin.value != null ? $scope.vehicle.vin.value.toUpperCase() : "";
            if (VinLookupEnabled) {
                $scope.invalidVIN = null;
                if ($scope.vehicle.vin.value && $scope.vehicle.vin.value.length > 0) {
                    $scope.readonly = true;
                    $scope.vinLoaded = false;
                    $q.when(VinLookupService.autofillBasedOnVIN($scope.vehicle.vin.value), (vehicleInfo) => {
                        if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                            // Autofill with the returned data
                            $scope.invalidVIN = false;
                            this.constructor.autofillVehicleFromLookup($scope.vehicle, vehicleInfo);
                            $scope.errorMsg = '';
                        } else {
                            // The VIN does not return a match, VIN is invalid
                            $scope.invalidVIN = true;
                            this.constructor.setBlankValuesOnVehicle($scope.vehicle);
                            $scope.vehicleImageUrl = undefined;
                        }
                        $scope.vinLoaded = true;
                    }, () => {
                        // Something has gone legitimately wrong, let the user input the data manually
                        $scope.errorMsg = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.errorMsg'); // POR-2061
                        $scope.readonly = false;
                        $scope.vinLoaded = true;
                        $scope.invalidVIN = null;
                    });
                } else {
                    $scope.readonly = false;
                    $scope.errorMsg = '';
                    this.constructor.setBlankValuesOnVehicle($scope.vehicle);
                }
            }
        };

    }

    static autofillVehicleFromLookup(vehicle, vehicleData) {
        vehicle.make.value = vehicleData.make;
        vehicle.model.value = vehicleData.model;
        vehicle.year.value = vehicleData.year;
    }

    static setBlankValuesOnVehicle(vehicle) {
        vehicle.make.value = '';
        vehicle.model.value = '';
        vehicle.year = undefined;
    }


}

PUWVinLookupCtrl.$inject = ['$scope', 'VinLookupEnabled', 'VinLookupService', 'SearchService', '$q', '$filter', '$stateParams'];

export default PUWVinLookupCtrl;
